// ********************************************************
// Scan Code
// Handles stuff like view and submit weights from Scan Code.
// ********************************************************

import * as Backend from '@/core/backend'

export async function loadRegistrations (params) {
  const res = await Backend.callApi({
    apiName: 'ScanCode.LoadRegistrations',
    inputData: {
      Facility: params.Facility,
      RegistrationType: params.RegistrationType
    }
  })
  if (!res.failed && res.data !== null) {
    // Sort so newest is top-most
    res.data = res.data.sort((a, b) => (a.CreatedData < b.CreatedData) ? 1 : ((b.CreatedData < a.CreatedData) ? -1 : 0))
  }
  return res
}

export async function loadRegistration (id) {
  const res = await Backend.callApi({
    apiName: 'ScanCode.LoadRegistration',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function isUsedRegistration (params) {
  const res = await Backend.callApi({
    apiName: 'ScanCode.IsUsedRegistration',
    inputData: {
      Facility: params.Facility,
      ScanXRegNo: params.ScanXRegNo
    }
  })
  return res
}

export async function loadScanXRegistration (params) {
  const res = await Backend.callApi({
    apiName: 'ScanCode.LoadScanXRegistration',
    inputData: {
      Facility: params.Facility,
      ScanXRegNo: params.ScanXRegNo
    }
  })
  return res
}

export async function saveRegistration (registration, saveOnlyComment = false) {
  const res = await Backend.callApi({
    apiName: 'ScanCode.SaveRegistration',
    inputData: {
      Registration: registration,
      SaveOnlyComment: saveOnlyComment
    }
  })
  return res
}

export async function printRegistration (id) {
  const res = await Backend.callApi({
    apiName: 'ScanCode.PrintRegistration',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function getWeight (params) {
  const res = await Backend.callApi({
    apiName: 'ScanCode.GetWeight',
    inputData: {
      ScaleId: params.ScaleId,
      ResetWeight: params.ResetWeight
    }
  })
  return res
}

export async function uploadWeight (params) {
  const res = await Backend.callApi({
    apiName: 'ScanCode.UploadWeight',
    inputData: {
      ScaleId: params.ScaleId,
      ScaleWeightData: params.ScaleWeightData
    }
  })
  return res
}

export async function getCurrentWeightIds (params) {
  const res = await Backend.callApi({
    apiName: 'ScanCode.GetCurrentWeightIds',
    inputData: {
      facility: params
    }
  })
  return res
}

export async function loadVehicles (param) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadVehicles',
    inputData: {
      // MITH special: If facility is '' show all vehicles for all facilities (we use facility = null).
      Facility: param.facility === '' ? null : param.facility,
      SearchText: param.searchText,
      LoadDeleted: false // never load Deleted
    }
  })
  return res
}

export async function loadFilteredArticles (params) {
  const res = await Backend.callApi({
    apiName: 'Archive.LoadArticles',
    inputData: {
      Facility: params.facilityNo,
      ArticleNoFilter: params.ArticleNoFilter
    }
  })
  return res
}
